import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { l_chevron_down, l_chevron_up } from '@fiverr-private/fit/icons';
import FileComments from '../FileComments';
import Time from '../Time';
import { ANNOTATION_CLICK_EVENT } from '../../../MediaViewer/consts';
import { collaborationEventBus } from '../../../Utils';
import * as GroupsSelectors from '../../selectors/groups';
import * as CommentsSelectors from '../../selectors/comments';

import './style.scss';

class RevisionRequest extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldShowComments: true
        };

    }

    componentDidMount = () => {
        collaborationEventBus.on(ANNOTATION_CLICK_EVENT, () => this.setState({ shouldShowComments: true }));
    }

    toggleComments = (e) => {
        e.stopPropagation();

        this.setState({
            shouldShowComments: !this.state.shouldShowComments
        });
    }

    render() {
        const {
            fileIds,
            revisionDate
        } = this.props;

        const {
            shouldShowComments
        } = this.state;

        if (!revisionDate) { return null; }

        return (
            <div className="revison-request-container">
                <div className="revison-request" onClick={this.toggleComments}>
                    <div className="revison-request-main">
                        <div className="circle"/>
                        <div className="revision-data">
                            <p className="name">Revision Request</p>
                            <p className="date"><Time dateTime={revisionDate}/></p>
                        </div>
                    </div>
                    <Icon className="file-chevron" size={12}>{shouldShowComments ? l_chevron_up : l_chevron_down}</Icon>
                </div>

                {shouldShowComments && <ol className="revision-request-comments">
                    {fileIds.map((fileId) => (
                        <FileComments key={fileId} fileId={fileId} isRevisionRequest={true}/>
                    ))}
                </ol>}
            </div>
        );
    }
}

RevisionRequest.defaultProps = {
    fileIds: [],
    revisionDate: 0
};

RevisionRequest.propTypes = {
    fileIds: PropTypes.array,
    revisionDate: PropTypes.number
};

const mapStateToProps = (state) => {
    const { id } = GroupsSelectors.getCurrentGroup(state);

    return {
        fileIds: GroupsSelectors.getFileIdsByGroupId(state, id),
        revisionDate: CommentsSelectors.getReviewCreatedAt(state)
    };
};

export default connect(mapStateToProps)(RevisionRequest);
